export const cookiesDialogData = [
  {
    idx: 1,
    type: '__essential',
    title: '필수 쿠키',
    isUse: false,
    contents: '',
  },
  {
    idx: 2,
    type: '__analytical',
    title: '분석/성능 쿠키',
    isUse: true,
    contents: 'analytical_cookies',
  },
  {
    idx: 3,
    type: '__functional',
    title: '기능 및 프로필 쿠키',
    isUse: false,
    contents: '',
  },
  {
    idx: 4,
    type: '__ads',
    title: '광고/타겟팅 쿠키',
    isUse: true,
    contents: 'ads_cookies',
  },
];
